import { useEffect, useState } from 'react';
import { AdvertiseModel } from '../../../models/advertise';
import axios from '../../../lib/axios';
import { DELETE_ADVERTISE, FIND_MANY_ADVERTISE } from '../../../lib/endpoints/advertise';
import { deleteNotificationService, getAllNotificationService } from '../../../services/notification';

export const useNotificationControllers = () => {
  const [openMenu, setOpenMenu] = useState(null);
  const [openForm, setOpenForm] = useState<boolean>(false);
  const [openDeleteForm, setOpenDeleteForm] = useState<boolean>(false);
  const [data, setData] = useState<AdvertiseModel[]>([]);
  const [selectedId, setSelectedId] = useState<string>(null!);
  const [loadingData, setLoadingData] = useState<boolean>(false);
  const [loadingButton, setLoadingButton] = useState<boolean>(false);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [searchValue, setSearchValue] = useState<string>('');

  const handleOpenForm = () => {
    setOpenForm(true);
  };

  const handleCloseForm = () => {
    setOpenForm(false);
    setOpenMenu(null);
  };

  const handleOpenMenu = (event: any, getId: string) => {
    setOpenMenu(event.currentTarget);
    setSelectedId(getId);
  };

  const handleCloseMenu = () => {
    setOpenMenu(null);
  };

  const handleChangePage = (event: any, newPage: any) => {
    setCurrentPage(newPage);
  };

  const handleSearchValue = (e: any) => {
    setCurrentPage(1);
    setSearchValue(e.target.value);
  };

  const handleOpenDeleteForm = () => {
    setOpenDeleteForm(true);
  };

  const handleCloseDeleteForm = () => {
    setOpenDeleteForm(false);
  };

  const filterData = data;

  const rows: AdvertiseModel[] = filterData?.slice((currentPage - 1) * 10, currentPage * 10);

  const countPagination = Math.ceil(filterData.length / 10);

  const isSearchNotFound = !filterData.length && !!searchValue;

  const handleFetchData = async () => {
    try {
      setLoadingData(true);
      const res = await getAllNotificationService()
      setData(res?.data);
    } catch (err) {
    } finally {
      setLoadingData(false);
    }
  };

  const handleDeleteNotification = async () => {
    try {
      setOpenMenu(null);
      setLoadingButton(true);
      await deleteNotificationService(selectedId)
      await handleFetchData();
      setOpenDeleteForm(false);
    } catch (err: any) {
      try {
        window.alert(err.response.data.message);
      } catch (err2) {
        window.alert('Server error please try again');
      }
    } finally {
      setLoadingButton(false);
    }
  };

  useEffect(() => {
    handleFetchData();
  }, []);

  return {
    openMenu,
    openForm,
    handleOpenForm,
    handleCloseForm,
    handleOpenMenu,
    handleCloseMenu,
    loadingData,
    rows,
    countPagination,
    isSearchNotFound,
    handleSearchValue,
    handleChangePage,
    currentPage,
    searchValue,
    handleFetchData,
    handleCloseDeleteForm,
    handleOpenDeleteForm,
    handleDeleteNotification,
    loadingButton,
    openDeleteForm,
  };
};
